import type { FC } from 'react';
import { Grid } from '@material-ui/core';
import { ResponsiveContainer, Pie, PieChart, Cell } from 'recharts';

const KpiTuberiaPie: FC<{ content: any[] }> = ({ content }) => {
  const COLORS = [
    '#1972b6',
    '#59bbfa',
    '#29c8c9',
    '#062043',
    '#d6bb74',
    '#f3883a',
    '#0e436b',
    '#007ccc',
    '#1a787a',
    '#011428',
    '#967a2b',
    '#a94c0a',
    '#298fdc',
    '#7acafa',
  ];
  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 1.2;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const { territorio: name } = content[index];
    return (
      <text
        x={x}
        y={y}
        fill={COLORS[index]}
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
        style={{ fontSize: '11px', fontWeight: 'bold' }}
      >
        {`${name} ${(percent * 100).toFixed(2)}%`}
      </text>
    );
  };

  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12} md={12}>
          <ResponsiveContainer aspect={2}>
            <PieChart>
              <Pie
                data={content}
                dataKey="facturacion"
                label={renderCustomizedLabel}
                cx="50%"
                cy="50%"
                isAnimationActive={false}
              >
                {content.map((entry, index) => {
                  const key = `cell-${index}`;
                  return (
                    <Cell key={key} fill={COLORS[index % COLORS.length]} />
                  );
                })}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </Grid>
      </Grid>
    </>
  );
};

export default KpiTuberiaPie;
